import { render, staticRenderFns } from "./AppModals.vue?vue&type=template&id=13bf27a4&"
import script from "./AppModals.vue?vue&type=script&lang=js&"
export * from "./AppModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports